import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Button, Modal } from 'react-bootstrap';
import { FormValidator } from '../../../helpers/form-validator';
import { uuid } from '../../../helpers/common';
import { Aux, Icon, Heading6, Validator, TitleIcon } from '../../widgets';
import "../../../../assets/css/react-datetime.css";
import { createDevice } from '../../../actions/eg-kanban';
import { getUserId } from '../../../helpers/session';
import { getOemUnknownDevice } from '../../../actions/oem';
import { getHardwareType } from '../../../actions/hardware';
import { getNetworkList } from '../../../actions/networkType';
const DeviceForm = (props) => {

    const getValidationRules = () => {
        const isRange = (value) => value.toString().trim().length === 0 || value.toString().trim().length < 36;
        const isSelect = (value) => { return (value === null) || (value === ""); }
        return new FormValidator([
            {
                field: 'serialNumber',
                method: 'isEmpty',
                validWhen: false,
                message: 'Serial number is required.'
            },
            {
                field: 'model',
                method: 'isEmpty',
                validWhen: false,
                message: 'Model is required.'
            },
            {
                field: 'deviceId',
                method: isRange,
                validWhen: false,
                args: [{ max: 36 }],
                message: 'Device id maximum is {max}'
            },
            {
                field: 'hardwareTypeId',
                method: isSelect,
                validWhen: false,
                message: 'Hardware Type is required.'
            }
        ])
    }

    let validator = getValidationRules();

    const initialState = {
        serialNumber: "",
        model: "",
        deviceId: "",
        hardwareTypeId: 4,
        submitted: false,
        validation: validator.valid(),
        networkListId: null
    };

    const dispatch = useDispatch();
    const [state, setValue] = useState(initialState);
    const [isUseExistDevice, setUseExistDevice] = useState(false);

    const { payload: unknownId, isRequesting } = useSelector(state => state.oem.unknownDevices);
    const { payload: hardwareType } = useSelector(state => state.hardware.hardwareType);
    const networkList = useSelector((state) => state.network.networkList.payload);
    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);

    const hardwareTypeList = useMemo(() => {
        return hardwareType.map((e) => ({
            value: e.hardware_type_id,
            label: e.hardware_type_name
        }))
    }, [hardwareType])

    const allNetworkList = useMemo(() => {
        return networkList ? networkList.map((e) => ({
            value: e.network_uuid,
            label: e.device_name ? `${e.name} (${e.device_name})` : e.name
        })) : []
    }, [networkList])

    useEffect(() => {
        if (props.show) {
            dispatch(getHardwareType());
            dispatch(getOemUnknownDevice());
            dispatch(getNetworkList(farmId));
        }
    }, [props.show])

    const setState = (params) => {
        setValue({ ...state, ...params });
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setState({ [name]: value });
    }

    const handleSelect = (event, name) => {
        if (event) setState({ [name]: event.value });
        else setState({ [name]: null });
    }

    const saveResource = () => {
        const validation = validator.validate(state);
        setState({ validation, submitted: true });

        if (validation.isValid) {
            const s = state;
            const getNetworkTypeId = networkList.length > 0 ? networkList.filter((network) => network.network_uuid === s.networkListId) : [];
            const params = {
                device_uuid: s.deviceId,
                farm_uuid: props.farmId,
                serial_number: s.serialNumber,
                model: s.model,
                hardware_type_id: s.hardwareTypeId,
                network_uuid: s.networkListId,
                network_type_id: getNetworkTypeId.length > 0 ? getNetworkTypeId[0].network_type_id : null,
                created_by: getUserId(),
                __version: 1,
                ...s.hardwareTypeId !== 4 && {
                    use_can_interface: false,
                    can_code: "",
                    qapp_version: "4.1.6",
                    qapp_version_code: 1,
                    os_version: "13.0.0",
                }
            }

            props.actions.createDevice(params, (res) => {
                if (res) {
                    disposeForm();
                }
            });
        }
    }

    const disposeForm = () => {
        setState({ ...initialState, validation: validator.valid(), submitted: false });
        props.onHide();
    }

    const s = state;
    const validation = s.submitted ? validator.validate(state) : state.validation;

    return (<Modal show={props.show} onHide={disposeForm} backdrop="static" className="modal-form">
        <Form className="eg-form m-1">
            <Modal.Header closeButton>
                <Modal.Title>
                    <Heading6>
                        <TitleIcon className="fa fa-mobile" />
                        Add Device
                    </Heading6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-0">
                <Aux>
                    <Form.Group>
                        <Validator validation={validation.hardwareTypeId}>
                            <Form.Label htmlFor="hardwareTypeId">Hardware Type<Validator.Mand /></Form.Label>
                            <Form.Select
                                id="hardwareTypeId"
                                placeholder="Select Hardware Type"
                                name="hardwareTypeId"
                                onChange={(e) => handleSelect(e, "hardwareTypeId")}
                                value={hardwareTypeList.length > 0 ? s.hardwareTypeId : null}
                                options={hardwareTypeList}
                            />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Aux>
                <Aux>
                    <Form.Group>
                        <Validator validation={validation.serialNumber}>
                            <Form.Label htmlFor="txtserialNumber">Serial Number <Validator.Mand /></Form.Label>
                            <Form.Control id="txtserialNumber" type="text" placeholder="Enter the serial number/imei" className="form-control" autoComplete="off"
                                value={s.serialNumber} name="serialNumber" onChange={handleChange} />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Aux>
                <Aux>
                    <Form.Group>
                        <Validator validation={validation.model}>
                            <Form.Label htmlFor="txtmodel">Model <Validator.Mand /></Form.Label>
                            <Form.Control id="txtmodel" type="text" placeholder="Enter the model" className="form-control" autoComplete="off"
                                value={s.model} name="model" onChange={handleChange} />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Aux>
                <Aux>
                    <Form.Group>
                        <Validator validation={validation.deviceId}>
                            <Form.Label htmlFor="deviceId">Device Id <Validator.Mand /></Form.Label>
                            <div className='d-flex'>
                                <Form.Control id="deviceId" type="text" style={{ width: "100%" }} placeholder="Enter the device id" className="form-control" autoComplete="off"
                                    value={s.deviceId} name="deviceId" onChange={handleChange} maxLength={36} />
                                <div className='d-flex ml-2 mt-1'>
                                    <Button variant='danger' title='Clear' size='sm' onClick={() => setState({ deviceId: "" })}><i className="fa fa-trash" aria-hidden="true"></i></Button>
                                    <Button variant='info' className='ml-1' title='Generate Id' size='sm' onClick={() => { setState({ deviceId: uuid() }); setUseExistDevice(false); }} ><i className="fa fa-plus-circle" aria-hidden="true"></i></Button>
                                    {unknownId.length !== 0 && <Button variant='info' className='ml-1' title='Search device Id' size='sm' onClick={() => setUseExistDevice(!isUseExistDevice)}><i className="fa fa-search" aria-hidden="true"></i></Button>}
                                </div>
                            </div>
                            <Validator.Text />
                        </Validator>

                        {isUseExistDevice && !isRequesting && unknownId.length !== 0 && <div className='mt-3 unknown-device-list' >
                            {
                                unknownId.map((id, index) => (
                                    <div key={index} className='p-1'
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setState({ deviceId: id })}>
                                        <TitleIcon className="fa fa-mobile mr-1 ml-1" /> <span
                                            style={{ fontWeight: s.deviceId === id ? "bold" : "normal" }}
                                        >{id}</span>
                                    </div>
                                ))
                            }
                        </div>}
                    </Form.Group>
                </Aux>
                <Aux>
                    <Form.Group>
                        <Form.Label htmlFor="hardwareTypeId">Network</Form.Label>
                        <Form.Select
                            id="networkListId"
                            placeholder="Select Network List"
                            name="networkListId"
                            onChange={(e) => handleSelect(e, "networkListId")}
                            value={allNetworkList.length > 0 ? s.networkListId : null}
                            options={allNetworkList}
                        />
                    </Form.Group>
                </Aux>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="danger" className="mr-2" onClick={disposeForm}><Icon className="fa fa-times"></Icon> Cancel</Button>
                <Button size="sm" variant="primary" onClick={saveResource}><Icon className="fa fa-floppy-o"></Icon> Save</Button>
            </Modal.Footer>
        </Form>
    </Modal >)
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        createDevice
    }, dispatch)
});

const mapStateToProps = state => ({
    save: state.equipmentGroup.save,
    farmId: state.egKanban.filters.farmId
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceForm);